import { render, staticRenderFns } from "./DepartmentIndicator.vue?vue&type=template&id=d98504a2"
import script from "./DepartmentIndicator.vue?vue&type=script&lang=js"
export * from "./DepartmentIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports